import './item.scss';
import React from 'react';
import { useHistory } from 'react-router';
import { getDefaultCover } from '@/utils';
import sysConfig from '../../sysConfig';

const { preRouteUrl } = sysConfig;
const { live: defaultActiveCover } = getDefaultCover();

export function ActiveItem(props) {
  const { cover, name, time, status } = props;

  const statusMapper = new Map([
    ['0', { text: '即将开始', className: 'will' }],
    ['1', { text: '进行中', className: 'ing' }],
    ['2', { text: '已结束', className: 'end' }],
  ]);

  return (
    <div className="activeItem">
      <div className="cover">
        <img src={cover || defaultActiveCover} alt="" />
      </div>
      <div className="name-status">
        <div className="name textOverflow">{name}</div>
        <div className={`status ${statusMapper.get(status).className}`}>
          {statusMapper.get(status).text}
        </div>
      </div>
      <div className="time textOverflow">{time}</div>
    </div>
  );
}

export function ActiveLiveItem(props) {
  const { cover, name, time, viewNum, status } = props;

  return (
    <div className="activeLiveItem">
      <div className="cover">
        <img src={cover || defaultActiveCover} alt="" />
      </div>
      <div className="right">
        <div className="name textOverflow">{name}</div>
        <div className="time textOverflow">{time}</div>
        <div className="attr textOverflow">
          {viewNum !== undefined && <div className="viewNum">{viewNum}</div>}
          {status === '1' && <div className="status">正在直播</div>}
        </div>
      </div>
    </div>
  );
}

export function ResItem(props) {
  const { id, resType, cover, name, dept, teacher, resAttr, viewNum, showViewNum = false } = props;

  const history = useHistory();

  const { res: defaultResCover } = getDefaultCover();

  return (
    <div className="resItem" onClick={() => history.push(`${preRouteUrl}/resPlay/${id}`)}>
      {resType === '1' ? (
        <div className="vertical">
          <div className="cover">
            <img src={cover || defaultResCover} alt="" />
          </div>
          <div className="name textOverflow">{name}</div>
          <div className="attr">
            <div className="teacher textOverflow">{teacher}</div>
            <div className="viewNum textOverflow">{viewNum}</div>
          </div>
        </div>
      ) : (
        <div className="level">
          <div className={`cover ${resType === '3' ? 'text' : 'image'}`}>
            <img src={cover || defaultResCover} alt="" />
          </div>
          <div className="right">
            <div className="name textOverflow">{name}</div>
            <div className="dept textOverflow">{dept}</div>
            <div className="attr textOverflow">
              <div className="teacher textOverflow">{teacher}</div>
              {resAttr ? <div className="resAttr textOverflow">{resAttr}</div> : undefined}
              {showViewNum ? <div className="viewNum textOverflow">{viewNum}</div> : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
